import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const NotificationsInboxPage = lazy(() =>
  import('./routes/NotificationsInboxPage').then((m) => ({ default: m.NotificationsInboxPage })),
);

/**
 * The in-app notifications behind the bell. Any signed-in person reads their own, whatever they
 * have been assigned, so the route sits outside the product guard like the account screens.
 */
export const notificationRoutes: RouteObject[] = [
  { path: ROUTES.alerts, element: <NotificationsInboxPage /> },
];

/** The four counts. The top bar's bell reads `unread` from it. */
export { useAlertSummary } from './hooks/useAlerts';
